import React from 'react'
import type { Icon } from 'shared/utils'

const Hamburger = (props: Icon) => {
    const { className = 'hamburger', color = 'black', size = 40 } = props
    return (
        <svg className={className} width={size} height={size} fill={color}>
            <path
                d="M5 30h30v-3.333H5V30zm0-8.333h30v-3.334H5v3.334zM5 10v3.333h30V10H5z"
                fillRule="evenodd"
            />
        </svg>
    )
}

export { Hamburger }
